import { render, staticRenderFns } from "./DashboardFamilyOrders.vue?vue&type=template&id=130b589a&"
import script from "./DashboardFamilyOrders.vue?vue&type=script&lang=js&"
export * from "./DashboardFamilyOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports